<template>
  <q-page class="q-pa-xl">
    <div class="fit row wrap justify-between items-start content-start align-start">
      <div class="col-xs-12">
        <span class="text-h4">{{ $page.props.i18n.title }}</span>
      </div>
    </div>

    <div class="row q-mt-lg">
      <!-- Categories selector buttons-->
      <q-tabs
        v-model="tab"
        align="justify"
        class="q-mb-md text-primary"
      >
        <q-tab
          v-for="category in categories"
          :key="category.id"
          :name="category.id"
          :label="category.name"
        />
      </q-tabs>
    </div>
    <q-tab-panels
      v-model="tab"
    >
      <q-tab-panel
        v-for="category in categories"
        :key="`${category.id}_tab`"
        :name="category.id"
        class="q-pa-none"
      >
        <div class="full_width row q-mt-xl q-col-gutter-md">
          <div
            v-for="partner in category.partners"
            :key="`${category.id}_tab_${partner.id}`"
            class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
          >
            <q-card class="equal-height-card fit q-pa-md">
              <q-card-section class="justify-start">
                <q-img
                  :src="`${$q.dark.isActive ? partner.logo_dark : partner.logo_light}`"
                  :alt="partner.name"
                  position="left"
                  no-transition
                  fit="contain"
                  height="22px"
                />
              </q-card-section>

              <div class="flex flex-column content-between full-height">
                <!-- Title and Description -->
                <div>
                  <!-- logo 64px height -->

                  <q-card-section class="text-bold q-pb-none">
                    {{ partner.name }}
                  </q-card-section>
                  <q-card-section class="text-caption text-muted q-pt-xs">
                    {{ partner.description }}
                  </q-card-section>
                  <q-card-section
                    v-if="partner.disclaimer"
                    class="text-caption text-muted text-italic q-pt-none"
                  >
                    {{ partner.disclaimer }}
                  </q-card-section>
                </div>

                <q-card-actions class="row">
                  <div class="col-12 text-right">
                    <q-btn
                      :href="partner.url"
                      target="_blank"
                      flat
                      class="btn-underline"
                      :label="$page.props.i18n.visit_website"
                      color="primary"
                      unelevated
                      no-caps
                      outline
                    />
                  </div>
                </q-card-actions>
              </div>
            </q-card>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import Layout from '@/layouts/workspace.vue';

export default {
  components: {
  },
  layout: Layout,
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tab: this.categories[0]?.id,
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  methods: {
  },
};
</script>

<style scoped>
.equal-height-card {
  display: flex;
  flex-direction: column;
}

.full-height {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
